<template>
  <div class="filter-wrapper mb-1">
    <input type="radio" :id="label" name="review-filter" class="d-none" :value="filter" :checked="value === filter" @input="$emit('input', filter)" />
    <label :for="label">
      <div depressed :class="['d-inline-block text-body-2 px-4 py-1 btn-border rounded-pill text-transform-none no-letter-spacing mr-3 filter-button white primary--text text--lighten-1']">
        {{ label }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true },
    label: {
      type: String,
      required: true
    },
    filter: {
      type: String,
      required: true
    }
  },

  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.filter-button {
  cursor: pointer;
  user-select: none;
}

.filter-wrapper > input:not(:checked) ~ label .filter-button {
  background-color: white !important;
  color: var(--v-light-green-base) !important;
}

.filter-wrapper > input:checked ~ label .filter-button {
  background-color: var(--v-light-green-base) !important;
  color: white !important;
}
</style>
